import { useListEntityApi } from '@/common/api/listEntityApi';
import type { OutboundDeliveryResponse } from './common/outboundDeliveryResponse';

interface OutboundDeliveryPageResponse {
  deliveries: OutboundDeliveryResponse[];
}

export interface ListOutboundDeliveryResponse {
  ok: true;
  deliveries: OutboundDeliveryResponse[];
}

export function useListOutboundDeliveryApi() {
  return useListEntityApi<ListOutboundDeliveryResponse>({
    url: 'delivery/outbound',
    translate: (t) => t.outboundDelivery.actions.fetchMany,
    async processOk(response) {
      const data = (await response.json()) as OutboundDeliveryPageResponse;
      return {
        ok: true,
        deliveries: data.deliveries,
      };
    },
  });
}
